import api from "@/lib/api";
function H() {
  const c = document.cookie.split(";").map(x=>x.trim()).find(x=>x.startsWith("active_hotel_id="));
  const v = c ? decodeURIComponent(c.split("=")[1]) : null;
  return { headers: v ? { "X-Hocp-Hotel": v } : {} };
}
export const kopsAPI = {
  dashboard: () => api.get("/kops/v1/dashboard", H()).then(r => r.data),
  activity:  (limit=50) => api.get("/kops/v1/activity", { ...H(), params: { limit } }).then(r => r.data),
  pantry:    () => api.get("/kops/v1/pantry", H()).then(r => r.data),
  createPantryItem: (b) => api.post("/kops/v1/pantry", b, H()).then(r=>r.data),
  updatePantryItem: (id, b) => api.patch(`/kops/v1/pantry/${id}`, b, H()).then(r=>r.data),
  requests:  (params={}) => api.get("/kops/v1/requests", { ...H(), params }).then(r=>r.data),
  createRequest: (b) => api.post("/kops/v1/requests", b, H()).then(r=>r.data),
  updateRequestStatus: (id, b) => api.post(`/kops/v1/requests/${id}/status`, b, H()).then(r=>r.data),
  waste:     (params={}) => api.get("/kops/v1/waste", { ...H(), params }).then(r=>r.data),
  createWaste: (b) => api.post("/kops/v1/waste", b, H()).then(r=>r.data),
  uploadPhoto: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post("/media/v1/upload", fd, H()).then(r => r.data);
  },
};

export const REQ_STATUS_ORDER = [
  "requested","reviewing","approved","picking","ready","delivered","kitchen_received","closed"
];
export const REQ_ALT = ["waiting","denied"];
export const REQ_TRANSITIONS = {
  requested:        ["reviewing","approved","waiting","denied"],
  reviewing:        ["approved","waiting","denied"],
  waiting:          ["reviewing","approved","denied"],
  approved:         ["picking"],
  picking:          ["ready"],
  ready:            ["delivered"],
  delivered:        ["kitchen_received"],
  kitchen_received: ["closed"],
  closed:           [],
  denied:           [],
};
export const REQ_STATUS_LABEL = {
  requested: "Requested", reviewing: "Reviewing", waiting: "Waiting",
  denied: "Denied", approved: "Approved", picking: "Picking",
  ready: "Ready", delivered: "Delivered", kitchen_received: "Kitchen Received",
  closed: "Closed",
};

export const REQ_STATUS_STYLE = {
  requested: "bg-slate-100 text-slate-700",
  reviewing: "bg-sky-100 text-sky-700",
  waiting:   "bg-amber-100 text-amber-700",
  denied:    "bg-rose-100 text-rose-700",
  approved:  "bg-emerald-100 text-emerald-700",
  picking:   "bg-violet-100 text-violet-700",
  ready:     "bg-cyan-100 text-cyan-700",
  delivered: "bg-teal-100 text-teal-700",
  kitchen_received: "bg-emerald-200 text-emerald-800",
  closed:    "bg-slate-200 text-slate-600",
};

export const WASTE_REASONS = ["waste","spoilage","burnt","expired","breakage","staff_meal","returned","sampling"];
